export default __webpack_public_path__ + "static/media/Annie 9781408355169.cb469019.jpg";